import { NumberInput } from '@frontend/components/basic-forms';
import { updateField } from '@frontend/repository';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

import useDimensionConstraintDataInput from './dimension-constraint-data-input.controller';

const ID = 'dimension-constraint-data-input';
export interface DimensionConstraintDataInputProps {
    dispatch: ThunkDispatch<any, any, Action>;
    formId: string;
    id?: string;
    label?: string;
    className?: string;
    required?: boolean;
}

const DimensionConstraintDataInput = (props: DimensionConstraintDataInputProps) => {
    const viewProps = useDimensionConstraintDataInput(props);

    return (
        <div
            id={ID}
            className='flex w-full flex-row'>
            <div className='m-1 w-1/4'>
                <NumberInput
                    id='height'
                    label='Height'
                    required
                    min={0}
                    value={viewProps.formValues?.height}
                    onChange={(value) => {
                        props.dispatch(updateField({ formId: props.formId, key: 'data', value: { ...viewProps.formValues, height: value } }));
                    }}
                />
            </div>
            <div className='m-1 w-1/4'>
                <NumberInput
                    id='width'
                    label='Width'
                    required
                    min={0}
                    value={viewProps.formValues?.width}
                    onChange={(value) => {
                        props.dispatch(updateField({ formId: props.formId, key: 'data', value: { ...viewProps.formValues, width: value } }));
                    }}
                />
            </div>
            <div className='m-1 w-1/4'>
                <NumberInput
                    id='depth'
                    label='Depth'
                    required
                    min={0}
                    value={viewProps.formValues?.depth}
                    onChange={(value) => {
                        props.dispatch(updateField({ formId: props.formId, key: 'data', value: { ...viewProps.formValues, depth: value } }));
                    }}
                />
            </div>
        </div>
    );
};

export default DimensionConstraintDataInput;
